// Material Dashboard 2 React layouts
import { Navigate } from 'react-router-dom';
import Dashboard from 'layouts/dashboard';
import Tables from 'layouts/tables';
import Profile from 'layouts/profile';
import SignIn from 'layouts/authentication/sign-in';
import SignUp from 'layouts/authentication/sign-up';
import ResetPassword from 'layouts/authentication/reset-password/cover';

// @mui icons
import Icon from '@mui/material/Icon';

const routes = [
  {
    type: 'collapse',
    name: 'Dashboard',
    key: 'dashboard',
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: '/dashboard',
    component: <Dashboard />,
  },
  {
    type: 'collapse',
    name: 'Order List',
    key: 'tables',
    icon: <Icon fontSize="small">table_view</Icon>,
    route: '/tables',
    component: <Tables />,
  },
  {
    // Deliveries are confirmed on the job in My Deliveries, with the ID photo
    key: 'billing',
    route: '/billing',
    component: <Navigate to="/tables" replace />,
  },
  {
    type: 'collapse',
    name: 'Profile',
    key: 'profile',
    icon: <Icon fontSize="small">person</Icon>,
    route: '/profile',
    component: <Profile />,
  },
  /* {
    type: 'collapse',
    name: 'Delivery Rates',
    key: 'delivery-rates',
    icon: <Icon fontSize="small">local_shipping</Icon>,
    href: 'https://jcgn.org/delivery-rates',
  }, */
  {
    type: 'collapse',
    name: 'Sign Out',
    key: 'sign-in',
    icon: <Icon fontSize="small">logout</Icon>,
    route: '/authentication/sign-in',
    component: <SignIn />,
  },
  {
    type: '',
    name: '',
    key: '',
    icon: <Icon fontSize="small"></Icon>,
    route: '/authentication/sign-up',
    component: <SignUp />,
  },
  {
    type: '',
    name: '',
    key: 'reset-password',
    icon: <Icon fontSize="small"></Icon>,
    route: '/authentication/reset-password',
    component: <ResetPassword />,
  },
];

export default routes;

// // Material Dashboard 2 React layouts
// import Dashboard from 'layouts/dashboard';
// import Tables from 'layouts/tables';
// import Billing from 'layouts/billing';
// import Profile from 'layouts/profile';
// import SignIn from 'layouts/authentication/sign-in';
// import SignUp from 'layouts/authentication/sign-up';

// // @mui icons
// import Icon from '@mui/material/Icon';

// // Get role from localStorage
// const role = localStorage.getItem("userRole"); 

// // Initialize route array
// const routes = [];

// // Common route for both 'seller' and 'deliver'
// if (role === "seller" || role === "deliver") {
//   routes.push({
//     type: 'collapse',
//     name: 'Order Confirmation',
//     key: 'billing',
//     icon: <Icon fontSize="small">receipt_long</Icon>,
//     route: '/billing',
//     component: <Billing />,
//   });
// }

// // Only include the rest if NOT a deliver
// if (role === "deliver") {
//   routes.push(
//     {
//       type: 'collapse',
//       name: 'Dashboard',
//       key: 'dashboard',
//       icon: <Icon fontSize="small">dashboard</Icon>,
//       route: '/dashboard',
//       component: <Dashboard />,
//     },
//     {
//       type: 'collapse',
//       name: 'Order List',
//       key: 'tables',
//       icon: <Icon fontSize="small">table_view</Icon>,
//       route: '/tables',
//       component: <Tables />,
//     },
//     {
//       type: 'collapse',
//       name: 'Profile',
//       key: 'profile',
//       icon: <Icon fontSize="small">person</Icon>,
//       route: '/profile',
//       component: <Profile />,
//     },
//     {
//       type: 'collapse',
//       name: 'Sign Out',
//       key: 'sign-in',
//       icon: <Icon fontSize="small">logout</Icon>,
//       route: '/authentication/sign-in',
//       component: <SignIn />,
//     },
//     {
//       type: '',
//       name: '',
//       key: '',
//       icon: <Icon fontSize="small"></Icon>,
//       route: '/authentication/sign-up',
//       component: <SignUp />,
//     }
//   );
// }

// export default routes;
